import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { Router } from '@angular/router';
import { AIRPLANEGALLERY } from 'src/app/data/_AIRPLANEGALLERY';

@Component({
  selector: 'app-fleet',
  templateUrl: './fleet.component.html',
  styleUrls: ['./fleet.component.scss']
})
export class FleetComponent implements OnInit {
  public _AIRPLANEGALLERY = AIRPLANEGALLERY;
  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService, private _router: Router) { }

  ngOnInit() {
  }

  goto(id: string) {
    const url = 'fleet/airplane-gallery/' + id;
    this._router.navigate([url]);

  }

}
